<template>
    <div :class="getClasses()">
        <div class="container">
            <div class="navbar-header">
                <button class="menu-toggle" aria-controls="primary-menu" aria-expanded="false" @click="this.toggleMenu"></button>
            </div>
            <nav>
                <ul class="menu" ref="menu">
                    <template v-if="lang == 'fr'">
                        <li>
                            <router-link to="/femme">FEMME</router-link>
                        </li>
                        <li>
                            <router-link to="/homme">HOMME</router-link>
                        </li>
                        <li>
                            <router-link to="/savoir-faire">Le savoir faire</router-link>
                        </li>
                        <li>
                            <router-link to="/gants-et-sport">Gants et sports</router-link>
                        </li>
                        <li>
                            <router-link to="/une-histoire">Une histoire</router-link>
                        </li>
                        <li>
                            <router-link to="/sur-mesure">Sur mesure...</router-link>
                        </li>
                        <li>
                            <router-link to="/presse">Vu dans la presse</router-link>
                        </li>
                        <li>
                            <router-link to="/accessoires">Accessoires</router-link>
                        </li>
                        <li class="order-action">
                            <router-link to="/acheter">Acheter</router-link>
                        </li>
                        <li>
                            <button class="flag en" v-on:click="setLanguage('EN')">EN</button>
                        </li>
                        <li v-if="nbItems > 0">
                            <button :class="'cart-action' + (this.$route.path == '/panier' ? ' active' : '')"  @click="openCart()"></button>
                        </li>
                    </template>
                    <template v-if="lang == 'en'">
                        <li>
                            <router-link to="/woman">WOMAN</router-link>
                        </li>
                        <li>
                            <router-link to="/man">MAN</router-link>
                        </li>
                        <li>
                            <router-link to="/know-how">Know-how</router-link>
                        </li>
                        <li>
                            <router-link to="/gloves-and-sports">Gloves & Sports</router-link>
                        </li>
                        <li>
                            <router-link to="/story">The real story</router-link>
                        </li>
                        <li>
                            <router-link to="/furnitures">furnitures</router-link>
                        </li>
                        <li>
                            <router-link to="/custom-made">Custom made...</router-link>
                        </li>
                        <li class="order-action">
                            <router-link to="/order">Buy Now</router-link>
                        </li>
                        <li>
                            <button class="flag fr" v-on:click="setLanguage('FR')">FR</button>
                        </li>
                        <li v-if="nbItems > 0">
                            <button :class="'cart-action' + (this.$route.path == '/cart' ? ' active' : '')" @click="openCart()"></button>
                        </li>
                    </template>
                </ul>
            </nav>
        </div>
    </div>

</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'MenuTop',
    data() {
      return {
        showMenu: false,
      };
    },
    props: ['lang'],
    computed: {
      ...mapGetters([
        'nbItems',
      ]),
    },
    methods: {

      getClasses() {
        let clz = 'navigation'; // container-fluid';
        if (this.showMenu) {
          clz += ' toggled';
        }
        return clz;
      },

      toggleMenu() {
        this.showMenu = !this.showMenu;
      },

      setLanguage(lang) {
        const routeName = this.$route.name;
        if (routeName.length <= 2) {
          return;
        }
        const newRouteName = routeName.substr(0, routeName.length - 2) + lang;
        const routes = this.$router.options.routes;
        const newRoute = this.$router.options.getRouteByName(routes, newRouteName);
        if (newRoute) {
          this.$router.push(newRoute);
        }
      },
      openCart() {
        const routes = this.$router.options.routes;
        const routeToCart = this.$router.options.getRouteByName(routes, `Checkout${this.lang.toUpperCase()}`);
        if (routeToCart) {
          this.$router.push(routeToCart);
        }
      },

    },
    watch: {
      $route: () => {
        // when route changes, toggle showMenu bool.
        this.showMenu = false;
      },
    },
  };
</script>
<style lang="scss">

    // Toggle (responsive)
    .menu-toggle,
    .navigation.toggled ul {
        display: block;
    }

    .navigation ul {
        display: none;
    }

    @media (min-width: 37.5em) {
        .menu-toggle {
            display: none;
        }
        .navigation ul {
            display: block;

            li {
                display: inline-block;
                position: relative;
            }
        }
    }

    @media (max-width: 37.5em) {
        .navbar-header {
            height: 3rem;
        }
    }

    /* Menu design here*/
    .menu {
        list-style: none;
        margin: 0;
        padding-left: 0;
    }

    .menu li {
        margin: 0 0.2rem;
        text-transform: uppercase;
        border: 1px transparent solid;
        vertical-align: bottom;
        &.order-action {
            @media (min-width: 37.5em) {
                border: 1px #9c554b solid;
            }
        }

        a {
            font-size: 1rem;
            display: block;
            padding: 0 0.2rem;

            &:hover {
                color: white;
                text-decoration: none
            }
            &.active {
                background-color: #ebe9e8;
                &:hover {
                    color: #9c554b;
                    cursor: default;
                }

            }
        }
    }

    .navigation {
        text-align: center;
    }



    .flag {
        border:0;
        background-color: transparent;
        color:transparent;
        width:25px;
        height:25px;
        background-size: cover;
        opacity: 0.6;
        &:hover {
            cursor: pointer;
            opacity: 1;
        }

        &.en {
            background-image: url('../assets/flag_uk.png');
        }
        &.fr {
            background-image: url('../assets/flag_fr.png');
        }
    }

    .cart-action {
        background: url('../assets/cart.png') no-repeat center bottom;
        width: 32px;
        height: 32px;
        border:1px transparent solid;
        background-size: cover;
        &:hover {
            cursor: pointer;
        }

        &.active {
            background-color: #BBB;
            border-color:grey;
        }
    }

    .menu-toggle {
        border: 1px grey solid;
        border-radius: 10px;
        overflow: visible;
        float: right;
        color: transparent;
        position: relative;
        margin-right: 1rem;
        margin-top: 0.5rem;
        width: 40px;
        height: 40px;
        cursor: pointer;

        &:after {
            content: '';
            position: absolute;
            display: block;
            width: 1rem;
            height: 0;
            top: 2px;
            left: 10px;
            box-shadow: 0 10px 0 1px #a7a096, 0 16px 0 1px #a7a096, 0 22px 0 1px #a7a096;
        }

        &:hover {
            background-color: white;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Navigation.vue